/*eslint react/no-deprecated: 0*/

import React from 'react';
import moment from 'moment';
import { Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import FontAwesome from 'react-fontawesome';

import { Field, reduxForm } from 'redux-form/immutable';
import * as validations from 'modules/forms/validations';
import { FORM_VEHICULOS } from 'modules/forms/formConstants';
import { TextFieldF } from 'modules/forms/component';

import * as vehiculosActions from 'modules/vehiculos/action';
import * as generalActions from 'modules/general/action';
import { CancelarButtonC, SeleccionadorC } from 'modules/general/component';

moment.locale('es');

class Add extends React.Component {
  componentDidMount() {
    if (this.props.params.vehiculoId == 'new') this.props.dispatch(generalActions.dashboard_changeTitle('NUEVO VEHICULO'));
    else {
      this.props.dispatch(vehiculosActions.getById(this.props.params.vehiculoId));
      this.props.dispatch(generalActions.dashboard_changeTitle('MODIFICAR VEHICULO'));
    }
  }
  componentWillReceiveProps = (nextProps) => nextProps.vehiculo.size != this.props.vehiculo.size && setValues(this.props.change, nextProps.vehiculo);
  componentWillUnmount = () => this.props.dispatch(vehiculosActions.clear('vehiculo'));
  submitForm = (data) => {
    data = data.toJS();
    if (this.props.vehiculo.get('_chofer')) data.choferId = this.props.vehiculo.getIn(['_chofer', 'id']);
    else data.choferId = false;
    if (this.props.vehiculo.get('_dispositivo')) data.dispositivoId = this.props.vehiculo.getIn(['_dispositivo', 'id']);
    else data.dispositivoId = false;
    if (data.cantAsientos) data.cantAsientos = Number(data.cantAsientos);
    this.props.dispatch(vehiculosActions.set(data, this.props.params.vehiculoId));
  };
  seleccionarChofer = (query) => {
    if (!query) this.props.dispatch(generalActions.seleccionador_open('_chofer'));
    this.props.dispatch(vehiculosActions.seleccionarChofer(query));
  };
  quitarChofer = () => this.props.dispatch(vehiculosActions.seleccionChofer(false));
  seleccionarDispositivo = (query) => {
    if (!query) this.props.dispatch(generalActions.seleccionador_open('_dispositivo'));
    this.props.dispatch(vehiculosActions.seleccionarDispositivo(query));
  };
  quitarDispositivo = () => this.props.dispatch(vehiculosActions.seleccionDispositivo(false));
  render = () => {
    return (
      <div>
        <Row className="rowContainer">
          <Col md={{ size: 4, offset: 4 }}>
            <MaterialUI.Paper zDepth={2} className="container">
              <form onSubmit={this.props.handleSubmit(this.submitForm)}>
                <Row>
                  <Col md="12">
                    <Field
                      name={'nombre'}
                      component={TextFieldF}
                      inputProps={{
                        fullWidth: true,
                        hintText: 'Nombre',
                        floatingLabelText: 'Identificación del vehiculo',
                      }}
                      validate={validations.required}
                    />
                  </Col>
                  <Col md="12">
                    <Field
                      name="patente"
                      component={TextFieldF}
                      inputProps={{
                        fullWidth: true,
                        hintText: 'Patente',
                        floatingLabelText: 'Patente del vehiculo',
                      }}
                    />
                  </Col>
                  <Col md="12">
                    <Field
                      name="cantAsientos"
                      component={TextFieldF}
                      inputProps={{
                        fullWidth: true,
                        hintText: 'Cantidad de asientos que tiene el vehiculo',
                        floatingLabelText: 'Asientos',
                      }}
                      validate={validations.number}
                    />
                  </Col>

                  <Col md="12">
                    <MaterialUI.Paper zDepth={1} className="p-10">
                      {this.props.vehiculo.get('_chofer') && (
                        <Row>
                          <Col md="12" className="m-10">
                            <p className="bolder"> Chofer predeterminado: </p>
                          </Col>
                          <Col md="6">
                            <Row>
                              <Col md="3">
                                <FontAwesome className="iconBar" name="user" />
                              </Col>
                              <Col md="9">
                                <p>
                                  <span className="title blue">{this.props.vehiculo.getIn(['_chofer', 'apellido'])}</span>
                                  <span className="bolder"> {this.props.vehiculo.getIn(['_chofer', 'nombre'])} </span>
                                </p>
                              </Col>
                            </Row>
                          </Col>
                          <Row>
                            <Col md="3">
                              <FontAwesome className="iconBar" name="address-card-o" />
                            </Col>
                            <Col md="9">
                              <p className="bolder p-7"> {this.props.vehiculo.getIn(['_chofer', 'documento'])} </p>
                            </Col>
                          </Row>
                        </Row>
                      )}
                      <Row>
                        <Col md={this.props.vehiculo.get('_chofer') ? '6' : '12'}>
                          <MaterialUI.RaisedButton
                            secondary={true}
                            label={this.props.vehiculo.get('_chofer') ? 'Cambiar chofer' : 'Seleccionar chofer'}
                            className="fullWidthComponent noPadding m-tb-20"
                            onTouchTap={() => this.seleccionarChofer()}
                          />
                        </Col>
                        {this.props.vehiculo.get('_chofer') && (
                          <Col md="6">
                            <MaterialUI.RaisedButton secondary={true} label={'Quitar chofer'} className="fullWidthComponent noPadding m-tb-20" onTouchTap={() => this.quitarChofer()} />
                          </Col>
                        )}
                      </Row>
                    </MaterialUI.Paper>
                  </Col>

                  <Col md="12">
                    <MaterialUI.Paper zDepth={1} className="p-10 mt-20">
                      {this.props.vehiculo.get('_dispositivo') && (
                        <Row>
                          <Col md="12" className="m-10">
                            <p className="bolder"> Dispositivo: </p>
                          </Col>
                          <Col md="12">
                            <Row>
                              <Col md="1">
                                <FontAwesome className="iconBar" name="tablet" />
                              </Col>
                              <Col md="10" className="textLeft center_on_phone">
                                <p className="title blue textLeft center_on_phone">
                                  #{this.props.vehiculo.getIn(['_dispositivo', 'numero'])} - {this.props.vehiculo.getIn(['_dispositivo', 'nombre'])}{' '}
                                </p>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      )}
                      <Row>
                        <Col md={this.props.vehiculo.get('_dispositivo') ? '6' : '12'}>
                          <MaterialUI.RaisedButton
                            secondary={true}
                            label={this.props.vehiculo.get('_dispositivo') ? 'Cambiar dispositivo' : 'Seleccionar dispositivo'}
                            className="fullWidthComponent noPadding m-tb-20"
                            onTouchTap={() => this.seleccionarDispositivo()}
                          />
                        </Col>
                        {this.props.vehiculo.get('_dispositivo') && (
                          <Col md="6">
                            <MaterialUI.RaisedButton secondary={true} label={'Quitar dispositivo'} className="fullWidthComponent noPadding m-tb-20" onTouchTap={() => this.quitarDispositivo()} />
                          </Col>
                        )}
                      </Row>
                    </MaterialUI.Paper>
                  </Col>
                  {this.props.vehiculo.get('_codigo') && (
                    <Col md="12" className="pt-15">
                      <p className="bolder"> Codigo del vehiculo: {this.props.vehiculo.getIn(['_codigo', 'codigo'])} </p>
                    </Col>
                  )}
                </Row>
                <MaterialUI.RaisedButton type="submit" primary={true} disabled={this.props.invalid} label="GUARDAR" className="fullWidthComponent noPadding m-tb-20" />
              </form>
            </MaterialUI.Paper>
          </Col>
        </Row>
        <CancelarButtonC className="m-tb-20" dispatch={this.props.dispatch} />
        <SeleccionadorC
          nameId="_chofer"
          listComponent={listComponentVehiculo}
          searchText="Buscar por DNI, Email, Nombre o Apellido"
          buscar={(query) => this.seleccionarChofer(query)}
          title="Seleccione un chofer"
        />
        <SeleccionadorC
          nameId="_dispositivo"
          listComponent={listComponentDispositivo}
          searchText="Buscar nombre"
          buscar={(query) => this.seleccionarDispositivo(query)}
          title="Seleccione un dispositivo"
        />
      </div>
    );
  };
}

const listComponentVehiculo = (item, dispatch, close) => {
  return (
    <MaterialUI.ListItem
      key={item.get('id')}
      onTouchTap={() => dispatch(vehiculosActions.seleccionChofer(item)) && close()}
      primaryText={
        <Row>
          <Col md="6">
            <Row>
              <Col md="3">
                <FontAwesome className="iconBar" name="user" />
              </Col>
              <Col md="9">
                <p>
                  <span className="title blue">{item.get('apellido')}</span>
                  <span className="bolder"> {item.get('nombre')} </span>
                </p>
              </Col>
            </Row>
          </Col>
          <Col md="6">
            <Row>
              <Col md="3">
                <FontAwesome className="iconBar" name="address-card-o" />
              </Col>
              <Col md="9">
                <p className="bolder"> {item.get('documento')} </p>
              </Col>
            </Row>
          </Col>
        </Row>
      }
    />
  );
};

const listComponentDispositivo = (item, dispatch, close) => {
  return (
    <MaterialUI.ListItem
      key={item.get('id')}
      onTouchTap={() => dispatch(vehiculosActions.seleccionDispositivo(item)) && close()}
      primaryText={
        <Row>
          <Col md="6">
            <Row>
              <Col md="3">
                <FontAwesome className="iconBar" name="tablet" />
              </Col>
              <Col md="9">
                <p className="title blue">
                  #{item.get('numero')} - {item.get('nombre')}
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      }
    />
  );
};

/*
  Setea los datos en redux-Form
  */
const setValues = (change, vehiculo) => {
  change('nombre', vehiculo.get('nombre'));
  change('patente', vehiculo.get('patente'));
  change('cantAsientos', vehiculo.get('cantAsientos'));
};

Add = reduxForm({
  form: FORM_VEHICULOS,
  enableReinitialize: true,
})(Add);

Add = connect((store) => ({
  vehiculo: store.getIn(['vehiculos', 'vehiculo']),
  initialValues: { cantAsientos: 19 },
}))(Add);

export default Add;



// WEBPACK FOOTER //
// src/modules/vehiculos/components/add.js